import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'prodsum_id': {
    title: '汇总单号',
    type: 'input',
    equation: cusname
  },
  'matnr': {
    title: '产品',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  },
  'datum': {
    title: '创建时间',
    type: 'date',
    equation: all
  }
}

export const config1 = {
  'prodsum_id': {
    title: '汇总单号'
  },
  'prodsum_item': {
    title: '项目',
    width: 70
  },
  'product_id': {
    title: '产品编号',
    width: 200
  },
  'wlybrand': {
    title: '品牌'
  },
  'description': {
    title: '产品描述',
    width: 400
  },
  'degree': {
    title: '度数'
  },
  'planqty_box': {
    title: '计划数量(件)'
  },
  'planqty_bottle': {
    title: '计划数量(瓶)'
  },
  'planqty_ton': {
    title: '计划数量(吨)'
  },
  'kconfqty': {
    title: '确认数量(件)'
  },
  'lastconfm_qty': {
    title: '最终确认数量(件)',
    width: 150
  },
  'area': {
    title: '区域'
  },
  'abclv': {
    title: '等级'
  },
  'status': {
    title: '状态'
  },
  'remark': {
    title: '备注'
  },
  'mdescp': {
    title: '反馈'
  },
  'arvdate': {
    title: '到货时间'
  }
}

export const config2 = {
  'prodpl_id': {
    title: '生产计划单'
  },
  'prodpl_item': {
    title: '项目',
    width: 70
  },
  'prod_id': {
    title: '产品',
    width: 200
  },
  'wlybrand': {
    title: '品牌'
  },
  'description': {
    title: '产品描述',
    width: 400
  },
  'degree': {
    title: '度数'
  },
  'planqty_box': {
    title: '计划数量(件)'
  },
  'planqty_bottle': {
    title: '计划数量(瓶)'
  },
  'planqty_ton': {
    title: '计划数量(吨)'
  },
  'lastconfm_qty': {
    title: '最终确认数量(件)',
    width: 150
  },
  'prodsum_id': {
    title: '汇总计划编号'
  },
  'prodpltype': {
    title: '计划类型',
    width: 150
  },
  'name_soldto': {
    title: '客户名称',
    width: 200
  },
  'status': {
    title: '状态'
  },
  'datum': {
    title: '提交日期'
  },
  'arvdate': {
    title: '提交预计到货日期',
    width: 150
  }

}



// WEBPACK FOOTER //
// ./src/views/make-plan-manage/config/makePlanConfirm.js